import React from "react";

const normalizeLineWhitespace = (value) => value.replace(/[ \t]+/g, " ").trim();

const collapseBreaks = (value) =>
  value
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

const extractNodeText = (node) => {
  if (node === null || node === undefined || typeof node === "boolean") {
    return "";
  }

  if (Array.isArray(node)) {
    return node
      .map((child) => extractNodeText(child))
      .filter(Boolean)
      .join("\n\n");
  }

  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }

  if (!React.isValidElement(node)) {
    return "";
  }

  if (node.type === React.Fragment) {
    return extractNodeText(node.props.children);
  }

  const tagName =
    typeof node.type === "string" ? node.type.toLowerCase() : null;
  const childrenText = extractNodeText(node.props.children);

  if (!childrenText) {
    return tagName === "br" ? "\n" : "";
  }

  if (tagName === "li") {
    return `- ${normalizeLineWhitespace(childrenText)}`;
  }

  if (tagName === "ul" || tagName === "ol") {
    return childrenText;
  }

  return childrenText;
};

export const faqNodeToPlainText = (node) => {
  const text = extractNodeText(node);
  return collapseBreaks(
    text
      .split("\n")
      .map((line) => line.trimEnd())
      .join("\n"),
  );
};

export const buildFaqPageJsonLd = (url, entries = []) => {
  const questions = entries
    .map((entry) => {
      const answerText = faqNodeToPlainText(entry.answer);
      if (!entry.question || !answerText) {
        return null;
      }

      return {
        "@type": "Question",
        name: entry.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: answerText,
        },
      };
    })
    .filter(Boolean);

  if (!questions.length) {
    return null;
  }

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    url,
    inLanguage: "pt-BR",
    mainEntity: questions,
  };
};
